import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]


import store from '../store'
import { defineComponent, defineProps } from 'vue'
import draggable from 'vuedraggable'
import ViewRender from './ViewRender.vue'
import { DraggableEvent, findParentWithAttribute, isEmptyString, findTreeNode, BaseTree } from '../utils'
import { emptyPage } from '../config'
// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'PageEditor'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  item: {
    type: Object,
    required: true
  },
  tabName: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props

// 移除元素
const removeItem = (e:DraggableEvent, itemHeight:number) => {
  // 获取拖动元素的位置信息
  const x = e.originalEvent.clientX
  const y = e.originalEvent.clientY

  // 获取容器的位置信息
  const container = e.to
  const containerRect = container.getBoundingClientRect()
  const bottom = containerRect.bottom + itemHeight

  // 判断拖动元素是否在容器范围内
  if (x < containerRect.left || x > containerRect.right || y < containerRect.top || y > bottom) {
    // 拖动到了区域外
    console.log('removeItem 拖动到了区域外 item=', props.item.children[e.newDraggableIndex])
    // eslint-disable-next-line vue/no-mutating-props
    props.item.children.splice(e.newDraggableIndex, 1)
    store.state.selectItemInDraggable = {} as BaseTree
  } else {
    // 拖动在容器范围内
    console.log('removeItem item=', props.item.children[e.newDraggableIndex])
    store.state.selectItemInDraggable = props.item.children[e.newDraggableIndex]
    console.log('removeItem 拖动在容器范围内')
  }
}
// @click="click" 只是鼠标原始的点击事件， 没有 拖拽节点的数据属性
const click = (e: PointerEvent) => {
  const result = findParentWithAttribute(e.target as HTMLElement, 'data-draggable', null)
  if (result !== null) {
    // eslint-disable-next-line
    const elementId = result.getAttribute('id')
    // eslint-disable-next-line
    const nodeInfo = findTreeNode(store.state.pageItems, elementId!, '', 0)
    // eslint-disable-next-line
    store.state.selectItemInDraggable = nodeInfo!.node
  }
}

// 右边往左边拖动时的事件
const end = (e: DraggableEvent) => {
  console.log('end enter --------------------------------')
  removeItem(e, 0)
  console.log('end leave --------------------------------')
}
// 右边往左边拖动时的事件
const start = (e: DraggableEvent) => {
  console.log('start running --------------------------------')
}
// move回调方法
const add = (e: DraggableEvent) => {
  console.log('add enter e=', e)
  const itemHeight = e.item !== null ? e.item.clientHeight : 10
  removeItem(e, itemHeight)
  console.log('add leave -----------------------')
}
const log = (event: object) => {
  console.log('log enter -----------------------')
  console.log(event)
  console.log('log leave -----------------------')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(draggable), {
    list: __props.item.children,
    onStart: start,
    onEnd: end,
    onAdd: add,
    onClick: click,
    group: "itxst",
    animation: "300",
    style: _normalizeStyle(_unref(isEmptyString)(__props.item.draggableStyle)?__props.item.draggableStyle:_unref(emptyPage).draggableStyle),
    onChange: log,
    "item-key": "id",
    class: _normalizeClass(["pageInner", __props.item.draggableClass])
  }, {
    item: _withCtx(({ element }) => [
      _createElementVNode("div", {
        id: element.id,
        class: _normalizeClass(["list-group-item", element.draggableDivClass])
      }, [
        (_openBlock(), _createBlock(ViewRender, {
          tabName: __props.tabName,
          isEditPageMode: true,
          item: element,
          key: element.id
        }, null, 8, ["tabName", "item"]))
      ], 10, _hoisted_1)
    ]),
    _: 1
  }, 8, ["list", "style", "class"]))
}
}

})